import React from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import {settingsNextStep} from '../../actions/settings';

class Intro extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      modalTitle: this.props.wallConfig.step_one_box_title,
      modalText: this.props.wallConfig.step_one_text
    }
  }

  componentDidMount() {
    let _this = this;
    window.addEventListener('click', function(evt) {
      if(evt.target.closest('.help-modal') == null &&
        evt.target.closest('.inspiration-modal') == null &&
        evt.target.closest('.top-nav') == null) {
        _this.setState({
          showHelp: false,
          showInspiration: false
        })
      }
    })
  }

  onStepSelect(evt) {
    /*
    let step = $(evt.currentTarget);
    let title = step.data('title');
    let text = step.data('text');
    let url = step.data('url');
    this.setState({
      modalTitle: title,
      modalText: text,
      modalUrl: url,
      showHelp: false,
      showInspiration: false
    })
    */
  }

  onShowHelp() {
    this.setState({
      showHelp: true
    })
  }

  onCloseHelp(evt) {
    evt.preventDefault();
    this.setState({
      showHelp: false
    })
  }

  onShowInspiration() {
    this.setState({
      showInspiration: true
    })
  }

  onCloseInspiration(evt) {
    evt.preventDefault();
    this.setState({
      showInspiration: false
    })
  }

  nextStep(evt) {
    evt.preventDefault();
    this.props.settingsNextStep(2);
  }

  render() {
    /*
      <div className="step text-center" data-title="Step 4: Checkout" data-text="Purchase your gallery wall easily and all at once!" data-img-src={this.props.step4} onClick={this.onStepSelect.bind(this)}>
        <h3 className="step__title text-center">Step 4</h3>
        <img className="step__image" src={this.props.step4} alt="Step 4" />
        <p className="step__text text-center">Glæd dig</p>
      </div>
    */
    let stepsList =(
      <React.Fragment>
        <div className="step text-center" data-title={this.props.wallConfig.step_one_box_title} data-text={this.props.wallConfig.step_one_text} data-url={this.props.wallConfig.step_one_url} data-img-src={this.props.wallConfig.step_one_image} onClick={this.onStepSelect.bind(this)}>
          <h3 className="step__title text-center">{this.props.wallConfig.step_one_title}</h3>
          <p className="step__text text-center">{this.props.wallConfig.step_one_subtitle}</p>
          <img className="step__image" src={this.props.wallConfig.step_one_image} alt="Step 1" />
        </div>
        <div className="step text-center" data-title={this.props.wallConfig.step_two_box_title} data-text={this.props.wallConfig.step_two_text} data-url={this.props.wallConfig.step_two_url} data-img-src={this.props.wallConfig.step_two_image} onClick={this.onStepSelect.bind(this)}>
          <h3 className="step__title text-center">{this.props.wallConfig.step_two_title}</h3>
          <p className="step__text text-center">{this.props.wallConfig.step_two_subtitle}</p>
          <img className="step__image" src={this.props.wallConfig.step_two_image} alt="Step 2" />
        </div>
        <div className="step text-center" data-title={this.props.wallConfig.step_three_box_title} data-text={this.props.wallConfig.step_three_text} data-url={this.props.wallConfig.step_three_url} data-img-src={this.props.wallConfig.step_three_image} onClick={this.onStepSelect.bind(this)}>
          <h3 className="step__title text-center">{this.props.wallConfig.step_three_title}</h3>
          <p className="step__text text-center">{this.props.wallConfig.step_three_subtitle}</p>
          <img className="step__image" src={this.props.wallConfig.step_three_image} alt="Step 3" />
        </div>
      </React.Fragment>
    );

    let assetList = (
      <div className="steps-container d-flex flex-column justify-content-between flex-grow-1">
        <div className="steps-list__wrapper d-flex flex-column justify-content-center">
          {stepsList}
        </div>
        <div className="button-wrapper px-3">
          <a href="/" className="background-next text-center btn btn--large btn--secondary">{this.props.wallConfig.exit_btn_text}</a>
          <button className="background-next text-center btn btn--large btn--primary" onClick={this.nextStep.bind(this)}>{this.props.wallConfig.next_btn_text}</button>
        </div>
      </div>
    );

    let backgroundSrc = {backgroundImage: 'url("' + this.props.wallConfig.main_background + '")'};

    let mobileModal = (
      <div className="mobile-modal d-block d-lg-none d-xl-none">
        <div className="mobile-modal__body text-center d-flex flex-column justify-content-center">
          <div className="mobile-modal__header text-center">
            <p className="font--large">
              {this.props.wallConfig.mobile_title}
            </p>
          </div>
          <h3>
            {this.props.wallConfig.mobile_content}
          </h3>

          <a href={this.props.wallConfig.mobile_landing_url} className="text-center btn btn--large btn--secondary">{this.props.wallConfig.mobile_button_text}</a>
        </div>
      </div>
    )

    let modal = (
      <div className="intro-modal d-none d-lg-block">
        <div className="intro-modal__body text-center d-flex flex-column justify-content-center">
          <a className="intro-modal__link" onClick={this.nextStep.bind(this)}>
            <div className="intro-modal__header text-center">
              <p className="font--large">
                {this.state.modalTitle}
              </p>
            </div>
            <h3>
              {this.state.modalText}
            </h3>

            <p className="intro-modal__next-button text-center btn btn--large btn--secondary" onClick={this.nextStep.bind(this)}>{this.props.wallConfig.next_btn_text}</p>
          </a>
        </div>
      </div>
    );

    let backgroundDiv = (
      // background image
      // step text modal
      <div className="background-wrapper col-12 p-0" style={backgroundSrc}>
        {modal}
      </div>
    );

    let helpModal = null;
    if(this.state.showHelp) {
      let faqs = this.props.faqs.map((faq) => {
        return(
          <li className="help-modal__faq" key={"faq-" + faq.id}>
            <div className="help-modal__question">
              <a href={"#faq-" + faq.id} data-toggle="collapse" data-target={"#faq-" + faq.id}>
                <h5>{faq.question}</h5>
              </a>
            </div>
            <div className="help-modal__answer collapse" id={"faq-" + faq.id}>
              <p>{faq.answer}</p>
            </div>
          </li>
        )
      })
      helpModal = (
        <div className="help-modal">
          <a className="help-modal__close" href="#" onClick={this.onCloseHelp.bind(this)}>X</a>
          <div className="help-modal__title text-center">
            <h4>{this.props.wallConfig.help_title}</h4>
          </div>
          <div className="help-modal__body">
            <ul className="help-modal__faq-list">
              {faqs}
            </ul>
          </div>
        </div>
      )
    }

    let inspirationModal = null
    if(this.state.showInspiration) {
      let insp_text = this.props.wallConfig.insp_text.replaceAll('<a', '<a target="_blank"');
      inspirationModal = (
        <div className="inspiration-modal">
          <a className="inspiration-modal__close" href="#" onClick={this.onCloseInspiration.bind(this)}>X</a>
          <div className="inspiration-modal__title text-center">
            <h4>{this.props.wallConfig.insp_title}</h4>
            <div></div>
          </div>
          <div className="inspiration-modal__content"  dangerouslySetInnerHTML={{__html: insp_text}}></div>
        </div>
      )
    }

    let menu = (
      <div className="add-to-cart menu d-none d-lg-flex justify-content-between align-items-center">
      </div>
    )

    return(
      <div className="container-fluid image-wall d-none d-lg-block d-xl-block">
        <div className="row">
          <div className="settings-column col-lg-2 flex-column px-0 d-none d-lg-flex">
            <a className="settings-column__logo-link text-center" href="/">
              <img className="settings-column__logo" src={this.props.wallConfig.logo_url} alt="Visse Vasse" />
            </a>
            {assetList}
          </div>
          <div className="background-column col-lg-10 px-0">
            <div className="top-nav d-none d-lg-flex">
              <button className="btn btn--primary btn--large" onClick={this.onShowHelp.bind(this)}>{this.props.wallConfig.help_btn_text}</button>
              <button className="btn btn--primary btn--large mx-3" onClick={this.onShowInspiration.bind(this)}>{this.props.wallConfig.insp_btn_text}</button>
            </div>
            {backgroundDiv}
            {helpModal}
            {inspirationModal}
            {menu}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  shop: state.shop,
  settings: state.settings,
  products: state.products,
  wallConfig: state.wallConfig,
  backgrounds: state.backgrounds,
  frames: state.frames,
  faqs: state.faqs
})

const mapDispatchToProps = {
  settingsNextStep
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Intro);
